/* eslint-disable */
(function () {

  // Pares de campos a validar: [campo repetición, campo original]
  var PARES_EMAIL = [
    ['rep_email_vendedor',     'email_vendedor'],
    ['rep_email_comprador',    'email_comprador'],
    ['rep_email_facturacion',  'email_facturacion'],
  ];

  function getField(name) {
    return document.querySelector('[name="' + name + '"]');
  }

  function isVisible(el) {
    if (!el) return false;
    return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
  }

  // Inserta (o recupera) los dos indicadores debajo del campo rep_email
  function getOrCreateIndicators(repField) {
    var wrapper = repField.closest('.jet-form-builder-row') || repField.parentElement;

    var ok = wrapper.querySelector('.itp-email-match-ok');
    if (!ok) {
      ok = document.createElement('span');
      ok.className = 'itp-email-match-indicator itp-email-match-ok';
      ok.innerHTML = '&#10003; Los correos coinciden';
      wrapper.appendChild(ok);
    }

    var err = wrapper.querySelector('.itp-email-match-err');
    if (!err) {
      err = document.createElement('span');
      err.className = 'itp-email-match-indicator itp-email-match-err';
      err.innerHTML = '&#10007; Los correos no coinciden';
      wrapper.appendChild(err);
    }

    return { ok: ok, err: err };
  }

  // Devuelve: true = coinciden, false = no coinciden, null = par no activo
  function pairMatches(repName, origName) {
    var repField  = getField(repName);
    var origField = getField(origName);
    if (!repField || !origField) return null;
    if (!isVisible(repField)) return null;
    var repVal  = repField.value.trim();
    var origVal = origField.value.trim();
    if (!repVal) return false;
    return repVal === origVal;
  }

  // Actualiza los indicadores visuales y devuelve el estado del par
  function updatePair(repName, origName) {
    var repField = getField(repName);
    if (!repField || !isVisible(repField)) return null;

    var matches    = pairMatches(repName, origName);
    var indicators = getOrCreateIndicators(repField);

    if (matches === true) {
      indicators.ok.classList.add('visible');
      indicators.err.classList.remove('visible');
    } else if (matches === false) {
      indicators.ok.classList.remove('visible');
      indicators.err.classList.add('visible');
    } else {
      indicators.ok.classList.remove('visible');
      indicators.err.classList.remove('visible');
    }

    return matches;
  }

  // Evalúa todos los pares visibles y devuelve true si hay alguno inválido
  function hayParInvalido() {
    for (var i = 0; i < PARES_EMAIL.length; i++) {
      var result = updatePair(PARES_EMAIL[i][0], PARES_EMAIL[i][1]);
      if (result === false) return true;
    }
    return false;
  }


  // Intercepta el click en cualquier botón de avance/envío ANTES que JFB
  // Si hay pares inválidos, cancela la acción y fuerza actualización de indicadores
  function handleButtonClick(e) {
    var btn = e.target.closest(
      'button.jet-form-builder__next-page, ' +
      'button.jet-form-builder__submit, ' +
      '[data-jfb-action="go-next"]'
    );
    if (!btn) return;

    if (hayParInvalido()) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }

  function attachListeners() {
    // El indicador solo se muestra cuando el campo rep_email pierde el foco.
    // Si el usuario vuelve a editar el campo original, se oculta hasta el próximo blur.
    PARES_EMAIL.forEach(function (par) {
      var repName  = par[0];
      var origName = par[1];

      var repField  = getField(repName);
      var origField = getField(origName);

      // Mostrar/actualizar indicador al salir del campo de repetición
      if (repField) {
        repField.addEventListener('blur', function () {
          updatePair(repName, origName);
        });
      }

      // Si el usuario modifica el email original después de haber validado,
      // ocultar el indicador hasta que vuelva a salir del campo rep_email
      if (origField) {
        origField.addEventListener('input', function () {
          var repF = getField(repName);
          if (!repF) return;
          var indicators = getOrCreateIndicators(repF);
          indicators.ok.classList.remove('visible');
          indicators.err.classList.remove('visible');
        });
      }
    });

    // Interceptación del click con useCapture para ejecutarse ANTES que JFB
    var form = document.querySelector('form.jet-form-builder');
    if (form) {
      form.addEventListener('click',  handleButtonClick, true);
      form.addEventListener('submit', function (e) {
        if (hayParInvalido()) {
          e.preventDefault();
          e.stopImmediatePropagation();
        }
      }, true);
    }
  }

  function tryInit() {
    var anyPresent = PARES_EMAIL.some(function (par) {
      return !!getField(par[0]);
    });
    if (!anyPresent) return false;

    attachListeners();
    return true;
  }

  document.addEventListener('DOMContentLoaded', function () {
    if (!tryInit()) {
      var obs = new MutationObserver(function () {
        if (tryInit()) obs.disconnect();
      });
      obs.observe(document.body, { childList: true, subtree: true });
    }

    // Al cambiar de paso, ocultar todos los indicadores (estado limpio)
    function resetIndicators() {
      PARES_EMAIL.forEach(function (par) {
        var repF = getField(par[0]);
        if (!repF) return;
        var indicators = getOrCreateIndicators(repF);
        indicators.ok.classList.remove('visible');
        indicators.err.classList.remove('visible');
      });
    }
    document.addEventListener('jfb:page-change',              resetIndicators);
    document.addEventListener('jet-form-builder/page-change', resetIndicators);
  });

})();



// WEBPACK FOOTER //
// ./scripts/formularios-itp/form-email-match.js